import { createContext,useState,useEffect } from "react";
import {getAuth, onAuthStateChanged} from 'firebase/auth'

export const Context = createContext(null as any);
export function getRole(token) {
    if(token)
    {
    const arrayToken = token.split('.');
    const tokenPayload = JSON.parse(atob(arrayToken[1]));
    return tokenPayload?.role;
    }
    else{return null;}
  }

export function AuthContext({children}){
    const auth = getAuth();
    const [user,setUser] = useState(null);
    const [loading,setLoading] = useState(true)
   
    useEffect(() => {
       let unsubscribe;
       unsubscribe = onAuthStateChanged(auth, (currentUser:any) => {
           let obj:any = null;
           if(currentUser)
           {
                obj = {
                currentuser:currentUser,
                role:getRole(currentUser?.accessToken)
                    }
           }
           
           console.log(obj);
           setLoading(false)
           if(obj) setUser(obj)
           else{setUser(null)}
       });
       return () => {
           if(unsubscribe) unsubscribe();
       }
    },[])
    const values = {
       user: user,
       setUser: setUser
    }
   
   return <Context.Provider value={values}>
      {!loading &&
       children
      }
   </Context.Provider>
   }